import { __decorate, __metadata } from "tslib";
import { asyncTimeout } from '@1inch-community/core/async';
import { buildEvent, isRTLCurrentLocale, localeChange$, resizeObserver, subscribe, } from '@1inch-community/core/lit-utils';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { map } from 'lit/directives/map.js';
import { of, tap } from 'rxjs';
import { segmentedControlContainerStyle, segmentedControlItemStyle, } from './segmented-control.style';
let SegmentedControlElement = class SegmentedControlElement extends LitElement {
    constructor() {
        super(...arguments);
        this.size = 'm';
        this.items = [];
        this.itemRefList = [];
        this.caretRef = null;
    }
    static { this.tagName = 'inch-segmented-control'; }
    static { this.styles = [segmentedControlContainerStyle, segmentedControlItemStyle]; }
    render() {
        const classes = {
            [`container-${this.size}`]: true,
        };
        return html `
      <div class="container ${classMap(classes)}">
        ${map(this.items || [], (item) => this.getItemView(item))}
        <div class="caret"></div>
      </div>
    `;
    }
    async firstUpdated() {
        this.itemRefList = Array.from(this.renderRoot.querySelectorAll('div.item'));
        this.caretRef = this.renderRoot.querySelector('.caret');
        await this.updateComplete;
        this.requestUpdate();
        await asyncTimeout(60);
        this.caretRef?.classList.add('caret-transition');
        this.requestUpdate();
        await asyncTimeout(60);
        subscribe(this, [
            localeChange$.pipe(tap(() => this.updated())),
            this.parentElement
                ? resizeObserver(this.parentElement).pipe(tap(() => this.updated()))
                : of(),
        ]);
    }
    updated() {
        if (!this.caretRef)
            return;
        let offset = 0;
        let width = 0;
        for (const el of this.itemRefList) {
            if (el.classList.contains('select')) {
                width = el.offsetWidth;
                break;
            }
            offset += el.offsetWidth;
        }
        this.caretRef.style.width = `${width}px`;
        this.caretRef.style.transform = `translateX(${offset * (isRTLCurrentLocale() ? -1 : 1)}px)`;
    }
    getItemView(item) {
        const classes = {
            [`item-${this.size}`]: true,
            select: item.value === this.select?.value,
        };
        let templateRef = html `${item.label}`;
        if (item.template) {
            templateRef = item.template(item, item.value === this.select?.value, this.caretRef);
        }
        return html `
      <div
        @click="${(event) => this.onSelect(item, event)}"
        class="item ${classMap(classes)}"
      >
        ${templateRef}
      </div>
    `;
    }
    onSelect(item, event) {
        this.select = item;
        this.requestUpdate();
        this.dispatchEvent(buildEvent('change', item.value, event));
    }
};
__decorate([
    property({ type: String }),
    __metadata("design:type", String)
], SegmentedControlElement.prototype, "size", void 0);
__decorate([
    property({ type: Array, attribute: false }),
    __metadata("design:type", Array)
], SegmentedControlElement.prototype, "items", void 0);
__decorate([
    property({ type: Object, attribute: false }),
    __metadata("design:type", Object)
], SegmentedControlElement.prototype, "select", void 0);
SegmentedControlElement = __decorate([
    customElement(SegmentedControlElement.tagName)
], SegmentedControlElement);
export { SegmentedControlElement };
//# sourceMappingURL=segmented-control.element.js.map